// This file contains:
// 1. Set API base URL
// 2. Set API keys for 3rd party services e.g: Google Maps
// 3. Enable/disable JS animations and CSS transitions - helps with testing performance.

const origin = document.location.origin
const location = (!origin.includes('localhost')) ? origin : 'http://localhost/getit'

export default {
  origin: origin,
  api: location + '/wp-json/wp/v2',
  acf: location + '/wp-json/acf/v3',
  analyticsKey: 'UA-28451233-1',

  // Animation / Transition settings
  animations: {
    on: true,
  },
  transitions: {
    on: true,
  },
}

export const meta = {
  title: 'GET IT Productions',
  separator: '-',
  description: 'Get It Productions is a full service photo and motion production company that will help bring your project to life. Productions range from editorial shoots, advertising campaigns, and social media videos, to personal stories and tests.',
}



// WEBPACK FOOTER //
// ./src/settings.js